import React, { FC } from 'react';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import { Theme } from 'evcharging/app/themes';

interface PostTextProps {
  children: string;
}

const PostText: FC<PostTextProps> = (props) => {
  const { children } = props;
  const theme = useTheme();
  const styles = createStyles(theme);

  return <div className={styles.root} dangerouslySetInnerHTML={{ __html: children }} />;
};

const createStyles = (theme: Theme) => ({
  root: css`
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    color: #6e7c87;
    ${theme.breakpoints.mobile.down} {
      font-size: 16px;
    }

    p {
      padding-top: 16px;
    }

    ol,
    ul {
      padding-top: 18px;
      padding-left: 20px;
    }

    a {
      color: inherit;
    }

    blockquote {
      position: relative;
      max-width: 700px;
      margin: 0 auto;
      font-weight: 600;
      font-style: italic;
    }

    img {
      border-radius: 12px;
      max-width: 808px;
      margin-bottom: 24px;
    }

    h2 {
      margin: 36px 0 24px;
      color: #000;
    }

    h3 {
      margin: 12px 0 12px;
      color: #000;
    }
  `,
});

export default PostText;
